var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.isDeveloper
      ? _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("h3", [_vm._v("Debug Flags")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.flagSearchQuery,
                  expression: "flagSearchQuery"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "flagSearch",
                placeholder: "Search for debug flags"
              },
              domProps: { value: _vm.flagSearchQuery },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.flagSearchQuery = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flags-wrap" },
              [
                _vm._l(_vm.filteredFlags, function(flag, key) {
                  return _c("div", { key: key }, [
                    _c(
                      "label",
                      [
                        _c("toggle-button", {
                          attrs: {
                            cssColors: true,
                            name: key,
                            value: flag.isActive
                          },
                          on: {
                            change: function($event) {
                              return _vm.setFlag(key, flag.isActive)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(flag.title))])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", [_c("i", [_vm._v(_vm._s(flag.description))])]),
                    _vm._v(" "),
                    _c("hr")
                  ])
                }),
                _vm._v(" "),
                _vm.filteredFlagsIsEmpty
                  ? _c("div", { staticClass: "text-center" }, [
                      _c("p", [
                        _vm._v("\n\t\t\t\t\t\tNo flags found for "),
                        _c("b", [
                          _c("i", [
                            _vm._v("'" + _vm._s(_vm.flagSearchQuery) + "'")
                          ])
                        ])
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9" }, [
            _c("h3", [_vm._v("Access Token")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.token,
                  expression: "token"
                }
              ],
              staticClass: "form-control token-text",
              domProps: { value: _vm.token },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.token = $event.target.value
                }
              }
            })
          ])
        ])
      : _c("div", { staticClass: "col-md-12" }, [_vm._m(0)])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 col-md-offset-3" }, [
      _c(
        "div",
        { staticClass: "alert alert-warning", attrs: { role: "alert" } },
        [_vm._v("Sorry, you do not have permission to access this screen")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }